import React from "react";
import { colors } from "app/theme";
import Grid from "@mui/material/Grid";
import { useLocation } from "react-router-dom";
import { HeaderViewCommonBlockItem } from "app/components/header/sub-components/expanded-view/data";
import { ReactComponent as YourDataHubIcon } from "app/assets/vectors/HeaderProductViewYourDataHub.svg";
import { ReactComponent as AIDAIATIPublisherIcon } from "app/assets/vectors/HeaderProductViewAIDAIATIPublisher.svg";
import { useCMSData } from "app/hooks/useCMSData";
import { getCMSDataField } from "app/utils/getCMSDataField";

export const HeaderPublisherView: React.FC = () => {
  const cmsData = useCMSData({ returnData: true });
  const location = useLocation();
  const [activeButton, setActiveButton] = React.useState<string>("");

  const items = [
    {
      title: getCMSDataField(
        cmsData,
        "general.aidaPublisherText",
        "AIDA Publisher"
      ),
      icon: AIDAIATIPublisherIcon,
      subtitle: getCMSDataField(
        cmsData,
        "componentsHeader.aidaIatiPublisherSubText",
        "Publish your data to IATI registry with ease."
      ),
      link: "/publisher",
    },
    {
      title: getCMSDataField(
        cmsData,
        "general.yourDataHubText",
        "Your Data Hub"
      ),
      icon: YourDataHubIcon,
      subtitle: getCMSDataField(
        cmsData,
        "componentsHeader.yourDataHubSubText",
        "See your data visualised all in one place."
      ),
      link: "/data-hub",
    },
  ];

  const onPathnameChange = (value: string) => {
    switch (value) {
      case items[0].link:
        return items[0].title;
      case items[1].link:
        return items[1].title;
      default:
        return "";
    }
  };

  React.useEffect(() => {
    const newActiveButton = onPathnameChange(location.pathname);
    if (newActiveButton !== activeButton) {
      setActiveButton(newActiveButton);
    }
  }, [location.pathname]);

  return (
    <Grid container spacing={2}>
      {items.map((item) => (
        <Grid item xs={12} md={12} lg={4} xl={3} key={item.title}>
          <HeaderViewCommonBlockItem
            title={item.title}
            link={item.link}
            icon={<item.icon />}
            subtitle={item.subtitle}
            active={activeButton === item.title}
            hoverTitleColor={colors.primary.green}
          />
        </Grid>
      ))}
    </Grid>
  );
};
